import { attributeIds, itemIds, localeIds } from './itemIds'
import locales from './locales'

export function getAttribute (item, attributeId) {
  if (!item.hasOwnProperty('attr')) {
    return null
  }
  if (attributeId.substring(0, 1) !== '/') {
    attributeId = '/' + attributeId
  }
  for (let i in item.attr) {
    if (item.attr.hasOwnProperty(i)) {
      if (i === attributeId) {
        return item.attr[i]
      }
      for (let j in item.attr[i]) {
        if (item.attr[i].hasOwnProperty(j)) {
          getAttribute(item.attr[i][j], attributeId)
        }
      }
    }
  }
  return null
}

export function getString (attribute) {
  for (let i in attribute) {
    if (
      attribute.hasOwnProperty(i)
      && attribute[i].hasOwnProperty('data')
      && attribute[i].data.hasOwnProperty('string')
    ) {
      return attribute[i].data.string
    }
  }
  return null
}

export function getHref (attribute, removePrecedingSlash = true) {
  for (let i in attribute) {
    if (
      attribute.hasOwnProperty(i)
      && attribute[i].hasOwnProperty('data')
      && attribute[i].data.hasOwnProperty('href')
    ) {
      if (removePrecedingSlash === true) {
        return attribute[i].data.href.substring(1)
      }
      return attribute[i].data.href
    }
  }
  return null
}

export function getLocalizedString (attribute, localeId) {
  for (let i in attribute) {
    if (
      attribute.hasOwnProperty(i)
      && attribute[i].hasOwnProperty('data')
      && attribute[i].data.hasOwnProperty('localized_strings')
    ) {
      for (let l in attribute[i].data.localized_strings) {
        if (
          attribute[i].data.localized_strings.hasOwnProperty(l)
          && l === localeId
        ) {
          return attribute[i].data.localized_strings[l]
        }
      }
    }
  }
  return null
}

export function getName (property, preferredLanguage) {
  const localizedName = getAttribute(property, attributeIds['localized_name'])
  if (preferredLanguage) {
    const locale = locales.filter(l => l.shortLocale === preferredLanguage)
    if (localizedName !== null && locale && localeIds[locale]) {
      const localizedString = getLocalizedString(localizedName, localeIds[locale])
      if (localizedString !== null) {
        return localizedString
      }
    }
  }
  const name = getAttribute(property, attributeIds['name'])
  if (name !== null) {
    return getString(name)
  }
  return ''
}

export function getCityName (property, preferredLanguage, related) {
  const cityRef = getAttribute(property, attributeIds['city'])
  if (cityRef !== null) {
    const cityId = getHref(cityRef)
    if (cityId !== null) {
      const city = related.find(item => item.id === cityId)
      if (city) {
        return getName(city, preferredLanguage)
      }
    }
  }
  return ''
}

export function getCountryName (property, preferredLanguage, related) {
  const countryRef = getAttribute(property, attributeIds['country'])
  if (countryRef !== null) {
    const countryId = getHref(countryRef)
    if (countryId !== null) {
      const country = related.find(rel => rel.id === countryId)
      if (country) {
        return getName(country, preferredLanguage)
      }
    }
  }
  return ''
}

export function getGiataId (property) {
  const alias = getAttribute(property, attributeIds['alias'])
  if (alias !== null) {
    for (let i in alias) {
      if (
        alias.hasOwnProperty(i)
        && alias[i].hasOwnProperty('data')
        && alias[i].data.hasOwnProperty('namespace')
        && alias[i].data.namespace.hasOwnProperty('href')
        && alias[i].data.namespace.href === itemIds['namespace_giata_id']
        && alias[i].data.hasOwnProperty('code')
      ) {
        return alias[i].data.code
      }
    }
  }
  return null
}
